import { CommentListWrapper } from './styled.js'
import { useState, useEffect, memo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import Pagination from '@mui/material/Pagination';
import { commentSelector, tourDetailSelector } from "redux/selector"
import { useDispatch, useSelector } from 'react-redux';
import RowComment from '../RowComment/index.js';
import ListReplyComment from '../ListReplyComment/index.js';
import { useLocation } from 'react-router-dom';
import useParams from 'hooks/useParams.js';
import Modal from 'components/Modal/index.js';
import { useMemo } from 'react';
import { Button } from 'antd';
import { commentActions } from "redux/slice/commentSlice"

function CommentAsk({ callBack, currentPage, handleChangePaginate }) {
    const commentState = useSelector(commentSelector)
    const [idComment, setIdComment] = useState([])
    const [showModalEdit, setShowModalEdit] = useState(false)
    const [method, setMethod] = useState('')
    const [itemEdit, setItem] = useState('')
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const qSort = query.get("sort")
    const { setParams } = useParams()
    const [content, setContent] = useState("")
    const [errorContent, setErrorContent] = useState("")
    const dispatch = useDispatch()

    const handleShowModalEdit = (method, item) => {
        setItem(item)
        setContent(item.content)
        setMethod(method)
        setShowModalEdit(!showModalEdit)
    }

    const handleSetShowReplyComment = (id) => {
        if (idComment.includes(id)) {
            setIdComment(idComment.filter(item => {
                return item !== id
            }))
        }
        else {
            setIdComment([...idComment, id])
        }
    }

    const title = useMemo(() => {
        if (method === "update")
            return "Chỉnh sửa bình luận"
        if (method === "remove")
            return "Xóa bình luận"
        if (method === "block")
            return "Ẩn bình luận"
        return ""
    }, [method])


    const handleRemove = () => {
        dispatch(commentActions.remove({ id: itemEdit.id, callBack }))
        setShowModalEdit(false)
    }

    const handleUpdate = () => {
        const payload = {
            content: content.trim(),
        }
        if (content.trim().length > 12) {
            dispatch(commentActions.update({ id: itemEdit.id, data: payload, callBack }))
            setShowModalEdit(false)
            setErrorContent("")
        } else {
            setErrorContent("Vui lòng nhập bình luận tối thiểu 12 ký tự")
        }
    }
    const handleBlock = () => {
        const payload = {
            status: 1,
        }
        dispatch(commentActions.block({ id: itemEdit.id, data: payload, callBack }))
        setShowModalEdit(false)

    }

    return (
        <CommentListWrapper className='pt-20'>
            <span className='comment_ask_top_totalcomment mt-40 text-black'>{commentState.totalComment} Bình luận</span>
            <div className='comment_ask_top_filter'>
                <label>Sắp xếp theo:</label>
                <select value={qSort ? qSort : "DESC"} onChange={e => setParams({ sort: e.target.value })}>
                    <option value={'DESC'}>Bình luận mới nhất</option>
                    <option value={'ASC'}>Bình luận cũ nhất</option>
                </select>
            </div>

            {
                commentState.dataComment.length > 0 &&
                <ul className='comment_ask_list'>
                    {
                        commentState.dataComment.map((comment, index) => (
                            comment.status === 0 &&
                            <li className='comment_ask_list_item' key={index}>
                                <RowComment
                                    item={comment}
                                    callBack={callBack}
                                    handleShowModalEdit={handleShowModalEdit}
                                />
                                {
                                    commentState.dataReply.filter(it => {
                                        return it.parent_id === comment.id
                                    }).length > 0 && idComment.includes(comment.id) === false &&
                                    <div className='comment_ask_list_item_show' onClick={() => handleSetShowReplyComment(comment.id)}>
                                        <span>Xem tất cả {
                                            commentState.dataReply.filter(it => {
                                                return it.parent_id === comment.id
                                            }).length
                                        } câu trả lời</span>
                                        <i><FontAwesomeIcon icon="fa-solid fa-sort-down" /></i>
                                    </div>
                                }
                                {
                                    commentState.dataReply.filter(it => {
                                        return it.parent_id === comment.id
                                    }).length > 0 && idComment.includes(comment.id) &&
                                    <div className='comment_ask_list_item_hide' onClick={() => handleSetShowReplyComment(comment.id)}>
                                        <span>Ẩn tất cả {
                                            commentState.dataReply.filter(it => {
                                                return it.parent_id === comment.id
                                            }).length
                                        } câu trả lời</span>
                                        <i><FontAwesomeIcon icon="fa-solid fa-sort-up" /></i>
                                    </div>
                                }
                                <ListReplyComment
                                    id={idComment.includes(comment.id) ? comment.id : ''}
                                    callBack={callBack}
                                    handleSetShowReplyComment={handleSetShowReplyComment}
                                    idComment={idComment}
                                    handleShowModalEdit={handleShowModalEdit}
                                />
                            </li>
                        ))
                    }
                </ul>
            }
            {
                commentState.totalPage > 1 &&
                <div className='comment_pagination'>
                    <Pagination count={commentState.totalPage} color="primary"
                        onChange={(event, pageNumber) => handleChangePaginate(event, pageNumber)}
                        page={parseInt(currentPage)}
                    />
                </div>
            }
            {
                showModalEdit &&
                <Modal onClose={() => setShowModalEdit(false)}>
                    <div className='p-20 form_wrapper'>
                        <div className='text-black s-16 medium pb-5 bb-grey-1 text-center'>{title}</div>
                        <textarea
                            readOnly={method === "update" ? false : true}

                            className="form_content p-5 mt-15" value={content} onChange={(e) => setContent(e.target.value)}></textarea>
                        <p className="text-red ">{errorContent}</p>

                        <div className="flex-end px-15 mt-20">
                            <div>
                                {
                                    method === "update" &&
                                    <Button className="action-danger-1"
                                        onClick={handleUpdate}
                                    >{title}</Button>
                                }
                                {
                                    method === "remove" &&
                                    <Button className="action-danger-1" onClick={handleRemove}>{title}</Button>
                                }
                                {
                                    method === "block" &&
                                    <Button className="action-danger-1" onClick={handleBlock}>{title}</Button>
                                }
                            </div>
                            <div>
                                <Button className="action-primary ml-10" onClick={() => setShowModalEdit(false)}>Thoát</Button>
                            </div>
                        </div>
                    </div>
                </Modal>
            }
        </CommentListWrapper>
    )
}
export default memo(CommentAsk)